module.exports = __webpack_public_path__ + "static/img/1_0048.1bfc39b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0048.jpg
// module id = AgqN
// module chunks = 0